import { render, staticRenderFns } from "./ui-finder.vue?vue&type=template&id=1f5ae46a&scoped=true&"
import script from "./ui-finder.vue?vue&type=script&lang=js&"
export * from "./ui-finder.vue?vue&type=script&lang=js&"
import style0 from "./ui-finder.vue?vue&type=style&index=0&id=1f5ae46a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5ae46a",
  null
  
)

export default component.exports